import { createSlice } from '@reduxjs/toolkit';

import type { propsRefreshState } from './interfaces';

const initialState: propsRefreshState = {
  loading: false,
  success: false,
};

const refreshSlice = createSlice({
  name: 'refresh',
  initialState,
  reducers: {
    refreshRequest: (state) => {
      state.loading = true;
    },
    refreshSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    refreshFailure: (state) => {
      state.loading = false;
      state.success = false;
    },
    clearRefresh: () => initialState,
  },
});

export const {
  refreshRequest,
  refreshSuccess,
  refreshFailure,
  clearRefresh,
} = refreshSlice.actions;
export default refreshSlice.reducer;
